// Central SEO / GEO config for RGV Gaming
export const SITE_URL = "https://rgvgaming.com";

export const SERVICE_AREA = [
  "McAllen",
  "Mercedes",
  "Edinburg",
  "Pharr",
  "Weslaco",
  "Brownsville",
  "Harlingen",
];

// LocalBusiness structured data (service-area business — mobile trailer, no storefront)
export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "EntertainmentBusiness"],
  "@id": `${SITE_URL}/#business`,
  name: "RGV Gaming",
  alternateName: "RGV Gaming Mobile Esports",
  slogan: "We Bring Gaming To You",
  description:
    "RGV Gaming is a mobile gaming and esports experience serving McAllen, Mercedes, and the greater Rio Grande Valley. We bring PlayStation 5, Xbox Series X, Nintendo Switch, VR, and 10 gaming PCs to birthday parties, school events, corporate events, fundraisers, church lock-ins, and summer camps.",
  url: SITE_URL,
  image: `${SITE_URL}/assets/hero-photos/trailer-wrap-hero.png`,
  logo: `${SITE_URL}/assets/logos/rgv-gaming-logo-1600.png`,
  telephone: "+1-956-684-8211",
  email: "franco@rgvgaming.com",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Mercedes",
    addressRegion: "TX",
    postalCode: "78570",
    addressCountry: "US",
  },
  areaServed: SERVICE_AREA.map((city) => ({
    "@type": "City",
    name: `${city}, TX`,
  })),
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "09:00",
      closes: "19:00",
    },
  ],
});

// Product/Offer schema for a party package
export const packageSchema = (pkg) => {
  const numeric = /\$(\d+)/.exec(pkg.price);
  const offer = numeric
    ? {
        "@type": "Offer",
        price: numeric[1],
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
      }
    : { "@type": "Offer", availability: "https://schema.org/InStock" };
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: pkg.name,
    description: pkg.includes.join(", "),
    brand: { "@type": "Brand", name: "RGV Gaming" },
    offers: offer,
  };
};

// Event schema
export const eventSchema = (ev) => ({
  "@context": "https://schema.org",
  "@type": "Event",
  name: ev.title,
  startDate: ev.time ? `${ev.date}T${ev.time}` : ev.date,
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  eventStatus: "https://schema.org/EventScheduled",
  description: ev.description || `RGV Gaming event: ${ev.title}`,
  location: {
    "@type": "Place",
    name: ev.location || "Rio Grande Valley, TX",
    address: { "@type": "PostalAddress", addressRegion: "TX", addressCountry: "US" },
  },
  organizer: { "@type": "Organization", name: "RGV Gaming", url: SITE_URL },
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

// Per-page metadata
export const PAGE_META = {
  home: {
    path: "/",
    title: "RGV Gaming | Mobile Gaming Parties in McAllen & the Rio Grande Valley",
    description:
      "RGV Gaming brings a mobile esports lounge to you — birthday parties, school & corporate events, fundraisers and church lock-ins across McAllen, Mercedes and the greater Rio Grande Valley. 10 gaming PCs, PS5, Xbox, Switch & VR. Call 956-684-8211.",
  },
  about: {
    path: "/about",
    title: "About RGV Gaming | Mobile Esports Lounge Serving the RGV",
    description:
      "RGV Gaming runs 10 Intel NUC i7 gaming PCs with Pixio curved monitors, PS5, Xbox Series X, Switch OLED and Oculus Quest 3 — brought to your home or business across McAllen, Mercedes and the Rio Grande Valley.",
  },
  packages: {
    path: "/packages",
    title: "Gaming Party Packages & Pricing in McAllen | RGV Gaming",
    description:
      "Gaming party packages from $395: 2-hour and 3-hour parties, the Gaming Fanatic package ($525) and the Ultimate Gamer Esports package. Full setup, host included, T-Mobile 5G. Serving McAllen, Mercedes & the RGV.",
  },
  events: {
    path: "/events",
    title: "Gaming Events & Tournaments in the Rio Grande Valley | RGV Gaming",
    description:
      "Upcoming gaming tournaments and community game nights from RGV Gaming, serving McAllen, Mercedes and the greater Rio Grande Valley.",
  },
  "summer-camps": {
    path: "/summer-camps",
    title: "Esports & Gaming Summer Camps (Ages 7–17) in the RGV | RGV Gaming",
    description:
      "RGV Gaming esports and gaming summer camps run June–August for ages 7–17 — Minecraft, Roblox, Rocket League and more. Serving McAllen, Mercedes and the Rio Grande Valley. Call 956-684-8211.",
  },
};
